











import Component, { mixins } from 'vue-class-component';
import Header from '@/components/header/header.vue';

@Component
export default class HeaderComponentError extends mixins(Header) {
}
